// constants

const SET_THANK_YOU = "SET_THANK_YOU";
const EMPTY_THANK_YOU = "REMOVE_THANK_YOU";

// reducers

const initialState = {};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THANK_YOU:
      if (action.payload === {}) return { ...state };
      return { ...action.payload };
    case EMPTY_THANK_YOU:
      return {};
    default:
      return state;
  }
};
export default Reducer;

// actions

// export const setThankYou =
//   (arr = []) =>
//   async (dispatch) => {
//     dispatch({
//       type: SET_THANK_YOU,
//       payload: arr,
//     });
//   };

export const setThankYou = (arr = []) => {
  return {
    type: SET_THANK_YOU,
    payload: arr,
  };
};
export const emptyThankYou = () => async (dispatch) => {
  dispatch({
    type: EMPTY_THANK_YOU,
  });
};
